import axios from "axios";
import {API_ADMIN_URL, API_KEY} from "../../config/constants";
import { postRequest } from '../API'
/*********************************************************
* Function Name : list
* Description   : Get list of winners  
* By            : Afsar Ali
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : list
* Description   : Get list of winners  
* By            : Afsar Ali
*********************************************************/
export const checkWinner = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/check-winner`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : list
* Description   : Get list of winners  
* By            : Afsar Ali
*********************************************************/
export const voucherList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/voucher-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : createVoucher
* Description   : Get list of winners  
* By            : Afsar Ali
*********************************************************/
export const createVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/generate-voucher`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : createVoucher
* Description   : Get list of winners  
* By            : Afsar Ali
*********************************************************/
export const deleteVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/delete-voucher`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : verifyVoucher
* Description   : Verify voucher  
* By            : Afsar Ali
*********************************************************/
export const verifyVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/verify-voucher`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : assignVoucher
* Description   : Assign voucher  
* By            : Afsar Ali
*********************************************************/
export const assignVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/assign-voucher`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : payoutVoucher
* By            : Afsar Ali
*********************************************************/
export const payoutVoucher = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/voucher-complete-payout`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : list
* Description   : Get voucher details  
* By            : Afsar Ali
*********************************************************/
export const voucherDetails = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winning-vouchers/voucher-details`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : publicVoucherDetails
* Description   : Get voucher details without login
*********************************************************/
export const publicVoucherDetails = async (order_id = "") => {
    try {
        const res = await axios.post(
            `${API_ADMIN_URL}winning-vouchers/voucher-details`,
            { order_id },
            { headers: { key: API_KEY } }
        );
        if (res?.data?.status === true) {
            return { status: true, result: res?.data?.response?.result };
        }
        return { status: false, message: res?.data?.statusMessage || "Voucher not found." };
    } catch (error) {
        console.log(error);
        return { status: false, message: "Under Maintenance, Please try after some time." };
    }
};//End of Function
/*********************************************************
* Function Name : checTambolaWinner
* Description   : Get list of winners  
*********************************************************/
export const checTambolaWinner = async (options) =>{
    try {
        // const params = {
        //     url : `${API_ADMIN_URL}winning-vouchers/check-tambola-winners`,
        //     postData : options
        // }
        // const res = await postRequest(params);
        // if(res.status === true || res.status === 200){
        //     return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        // } else{
            return {status : false, message:"Under Maintenance, Please try after some time."}
        // }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function